import type { ReactNode } from 'react';

export function Title({ children }: { children: ReactNode }) {
  return <div className='mt-2 text-lg font-semibold'>{children}</div>;
}
